import { EpochGraphTypes, type SignalConfig } from '@/modules/epoch/types';
import type { DialogSettings, EpochState } from '../state';

export const getZoomRange =
  (state: EpochState) =>
  (signalName: string): [number, number] => {
    if (state.graph.zoom[signalName]) {
      return [state.graph.zoom[signalName].min, state.graph.zoom[signalName].max];
    }

    if (state.epochData.data?.mapping?.[signalName]) {
      return [
        state.epochData.data?.mapping[signalName].min,
        state.epochData.data?.mapping[signalName].max
      ];
    }
    return [0, 80];
  };

export const getEventsBySignal = (state: EpochState) => (signalName: string) => {
  if (!signalName || !state?.signalEvents) {
    return [];
  }

  return Array.isArray(state.signalEvents[signalName]) ? state.signalEvents[signalName] : [];
};

export const getSignalMapping =
  (state: EpochState) =>
  (signalName: string): SignalConfig | null => {
    const base = state.epochData?.data?.mapping?.[signalName];
    const zoom = state.graph?.zoom?.[signalName];

    if (!base && !zoom) return null;

    return {
      ...(base || { min: 0, max: 0 }),
      ...(zoom || {})
    } as SignalConfig;
  };

export const getSignalType =
  (state: EpochState) =>
  (signalName: string): EpochGraphTypes => {
    if (state.epochData.data?.mapping?.[signalName]?.vizmode) {
      return state.epochData.data?.mapping[signalName].vizmode as EpochGraphTypes;
    }

    return EpochGraphTypes.oneLine;
  };

export const getSettingDialog =
  (state: EpochState) =>
  (payload: keyof DialogSettings): boolean => {
    if (state.dialog[payload]) {
      return state.dialog[payload];
    }
    return false;
  };

export const isEpochViewLoading = (state: EpochState) =>
  state.events.isLoading ||
  state.eventActions.isLoading ||
  state.epochData.isLoading ||
  state.settings.isLoading;

export const getFullNightSignalData = (state: EpochState) => (signalName: string) => {
  const { data, isLoading } = state.fullNight;

  if (isLoading || !data) return null;

  const mapping = data.mapping?.[signalName];

  return {
    data: data.signal?.[signalName] ?? [],
    mapping: mapping ? { ...mapping } : null,
    graphType: mapping?.vizmode ?? EpochGraphTypes.oneLine
  };
};
